/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Training } from '../../models/training';

export interface ApiMasterTrainingGetAllGet$Params {
}

export function apiMasterTrainingGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterTrainingGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Training>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTrainingGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Training>>;
    })
  );
}

apiMasterTrainingGetAllGet.PATH = '/api/Master/Training/GetAll';
